<template>
  <div v-if="showPrompt" class="fixed top-0 left-0 w-full bg-white p-4 z-50 relative"
    style="box-shadow: 0 2px 3px 0px var(--color-primary, rgba(253, 97, 7, 0.22)), inset 0 0.5px 0px 0 var(--color-primary, rgba(253, 97, 7, 0.13));">
    <!-- Sluitknop rechtsboven -->
    <button @click="showPrompt = false"
      class="absolute top-2 right-2 text-gray-400 hover:text-gray-700 focus:outline-none" aria-label="Sluiten"
      type="button">
      <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 20 20" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 6l8 8M6 14L14 6" />
      </svg>
    </button>
    <!-- Twee regels, knoppen exact onder elkaar -->
    <div>
      <!-- Eerste regel -->
      <div class="flex items-center mb-2">
        <div class="w-96 text-sm text-gray-700">
          Uw taal is herkend als <strong>{{ detectedLocaleLabel }}</strong>. Klopt dit?
        </div>
        <button @click="acceptLocale" :disabled="selectedLocale !== page.props.locale"
          class="ml-4 bg-primary text-white inline-flex items-center border border-transparent py-1 font-semibold hover:bg-primary focus:bg-primary active:bg-primary focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2 transition ease-in-out duration-150 disabled:opacity-50 disabled:cursor-not-allowed rounded-md px-8 text-sm h-8">
          Ja, klopt
        </button>
      </div>
      <!-- Tweede regel -->
      <div class="flex items-center">
        <div class="w-96 flex items-center text-sm text-gray-500">
          Of kies een andere taal:
          <select v-model="selectedLocale"
            class="ml-2 px-2 py-1 rounded-md border border-gray-300 text-sm h-8 focus:ring-primary focus:border-primary transition"
            style="min-width: 120px; max-width: 160px;">
            <option v-for="name in supportedLocales" :value="name" :key="name">
              {{ name }}
            </option>
          </select>
        </div>
        <button @click="changeLocale"
          class="ml-4 bg-primary text-white inline-flex items-center border border-transparent py-1 font-semibold hover:bg-primary focus:bg-primary active:bg-primary focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2 transition ease-in-out duration-150 disabled:opacity-50 disabled:cursor-not-allowed rounded-md px-8 text-sm h-8">
          Wijzig taal
        </button>
      </div>
    </div>
  </div>
</template>



<script setup>
import { ref, onMounted } from 'vue';
import { usePage } from '@inertiajs/vue3';
import { computed } from 'vue';


const page = usePage()
const showPrompt = ref(false)
const selectedLocale = ref(page.props.locale)
const supportedLocales = page.props.supportedLocales

const detectedLocaleLabel = computed(() => supportedLocales[page.props.locale] || page.props.locale)
const selectedLocaleLabel = computed(() => supportedLocales[selectedLocale.value] || selectedLocale.value)


onMounted(() => {
  // Zet showPrompt true als er geen 'locale_user_selected' in localStorage/session, of via backend
  showPrompt.value = !page.props.localeUserSelected; // show whhen not selected
})

function acceptLocale() {
  updateLocale(selectedLocale.value, true)
}
function changeLocale() {
  updateLocale(selectedLocale.value, true)
}

const getCsrfToken = () => {
    // Gebruik __Host-XSRF-TOKEN bij https, anders XSRF-TOKEN
    const isHttps = window.location.protocol === 'https:';
    const cookieName = isHttps ? '__Host-XSRF-TOKEN' : 'XSRF-TOKEN';
    // const cookieName = 'XSRF-TOKEN';
    // console.log('getCsrfToken', cookieName);
    const token = RegExp(`${cookieName}=[^;]+`).exec(document.cookie);
    return token ? decodeURIComponent(token.toString().replace(/^[^=]+./, '')) : '';
};

function updateLocale(locale, userSelected) {
  fetch('/set-locale', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'X-CSRF-TOKEN': getCsrfToken() },
    body: JSON.stringify({ locale, user_selected: userSelected })
  }).then(() => {
    // Remove forceLocalePrompt from URL if present
    if (window.location.search.includes('forceLocalePrompt=1')) {
      const url = new URL(window.location);
      url.searchParams.delete('forceLocalePrompt');
      window.history.replaceState({}, '', url);
    }
    location.reload();
  })
}

</script>
